var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('quill-editor',{ref:"myQuillEditor",attrs:{"disabled":_vm.disabled,"options":_vm.editorOption},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})}
var staticRenderFns = []

export { render, staticRenderFns }